import React from 'react';
import './TopCollegesSection.css';
import { useCollegeDetQuery } from '../../store/api/userApiSlice';
import { IoArrowForward } from 'react-icons/io5';
import WideCollegeCard from './WideCollegeCard';

const TopCollegesSection = () => {
  const { data, isLoading } = useCollegeDetQuery();
  const allColleges = data?.data || data?.colleges || data?.institute || (Array.isArray(data) ? data : []) || [];

  // Filter for MBA colleges
  let colleges = allColleges.filter(college => {
    const queries = ['mba', 'management', 'business', 'pgdm'];
    
    // Helper to safely check array or string
    const checkField = (field) => {
      if (!field) return false;
      if (Array.isArray(field)) {
          return field.some(item => {
             const val = typeof item === 'string' ? item : (item.name || item.courseName || '');
             return queries.some(q => val.toLowerCase().includes(q));
          });
      }
      if (typeof field === 'string') {
        return queries.some(q => field.toLowerCase().includes(q));
      }
      return false;
    };

    const nameMatch = college.name && queries.some(q => college.name.toLowerCase().includes(q));

    return (
      nameMatch ||
      checkField(college.courses) || 
      checkField(college.course) || 
      checkField(college.program) || 
      checkField(college.programs) ||
      checkField(college.type) ||
      checkField(college.category)
    );
  });

  // Fallback: If no specific MBA colleges found (likely due to missing course data in list API),
  // show top colleges from the general list.
  if (colleges.length === 0) {
    colleges = allColleges;
  }

  return (
    <div className="top-colleges-wrapper">
      <section className="top-colleges-section">
        <div className="top-colleges-header">
          <h2 className="top-colleges-heading">Top MBA Colleges In INDIA</h2>
          <a href="/college-finder?q=MBA" className="view-all-colleges">
            VIEW ALL <IoArrowForward />
          </a>
        </div>
        
        <p className="top-colleges-subtext">
          Discover the best MBA colleges in India that offer quality education, expert faculty, and career-focused programs to help you become future-ready.
        </p>
        
        {/* Vertical Stack of Wide Cards */}
        <div className="top-colleges-stack" style={{ display: 'flex', flexDirection: 'column', gap: '24px', alignItems: 'center' }}>
          {colleges.slice(0, 4).map((college) => (
            <WideCollegeCard key={college._id} college={college} />
          ))}
        </div>

      </section>
    </div>
  );
};

export default TopCollegesSection;
